module.exports = __webpack_public_path__ + "img/tag.bd5cd1e2.svg";